export default {"src":"/_next/static/media/gl.d1dabbd4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};